export default "__VITE_ASSET__DAXY7hFo__"